import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import knock from 'actions/Broadcast/knock';

const useKnockRequest = () => {
  const dispatch = useDispatch();

  return useCallback(
    payload => {
      dispatch(knock(payload));
    },
    [dispatch]
  );
};

export default useKnockRequest;
